import component from './AddViewPage.vue'
export default component
